import { Actions } from '../../interfaces'
import { ComponentCategory } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { ComponentCategory },
  actions: { [ComponentCategory.name]: actions },
}
